import { api } from "../api";

/**
 * departmentFindAllExportResponse - Function that finds on database all departments by status and export in a PDF/XSLX file  
 * /departments/${secretaryId}/${status}/{exportType}  
 * method GET  
 * @async-function
 */
const departmentFindAllExportResponse = async (token: string, secretaryId: number, status: string, exportType: string) => {
    const response = await api.get(
        `/departments/${secretaryId}/${status}/${exportType}/export`, {
            responseType: "arraybuffer",
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
    return response;
};
export default departmentFindAllExportResponse;